export interface ParametricalElementItem {
	elemento: string;
}

export interface ParametricalCivilStateItem extends ParametricalElementItem {
	elemento: string;
	estadoCivil: string;
}

export interface ParametricalItem extends ParametricalElementItem {
	elemento: string;
	denomLarga: string;
}

export interface ParametricalCountryItem extends ParametricalItem {
	elemento: string;
	denomLarga: string;
	espania: number;
	pertenenciaUEEE: number;
}

export interface ParametricalLodgingTypeItem extends ParametricalElementItem {
	elemento: string;
	tipoAlojamiento: string;
}

export interface Item {
	id: string;
	name: string;
}

export interface CountryItem extends Item {
	id: string;
	name: string;
	isEspania: boolean;
	isEuropa: boolean;
}
